export default __webpack_public_path__ + "static/testing-0a97c886ec0fea43dc8a9780adf01f90.svg";